const drawerWidth = 200;
export const layoutCrawlersStyle = theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        zIndex: theme.zIndex.drawer + 1
    },
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    appBarSpacer: theme.mixins.toolbar
})